// extracted by mini-css-extract-plugin
export default {"img":"lUWlkS"};